import { render, staticRenderFns } from "./AddServiceGridRow.vue?vue&type=template&id=bd876dc2&scoped=true"
import script from "./AddServiceGridRow.vue?vue&type=script&lang=js"
export * from "./AddServiceGridRow.vue?vue&type=script&lang=js"
import style0 from "./AddServiceGridRow.vue?vue&type=style&index=0&id=bd876dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd876dc2",
  null
  
)

export default component.exports